import * as React from 'react';
import { Button } from '../Button/index.js';
export var Panel = function (_a) {
    var title = _a.title, views = _a.views;
    var _b = React.useState(0), selectedView = _b[0], setSelectedView = _b[1];
    var handlers = React.useMemo(function () { return views.map(function (_, i) { return function () { return setSelectedView(i); }; }); }, [views.length]);
    var CurrentContent = views[selectedView].Content;
    return (React.createElement("div", { className: "panel" },
        React.createElement("div", { className: "bar" },
            React.createElement("h3", { className: "panel-title" }, title),
            React.createElement("div", null, views.map(function (view, index) { return (React.createElement(Button, { key: index, title: view.toolTip, onClick: handlers[index], kind: index === selectedView ? 'primary' : 'secondary' }, view.icon)); }))),
        React.createElement(CurrentContent, null)));
};
//# sourceMappingURL=index.js.map